export default {
  language: { name: "English", code: "en", rtl: false },
  languages: [
    {
      code: "en",
      dir: "ltr",
      name: "English",
    },
  ],
  currency: {
    locale: "en-AU",
    code: "AUD",
  },
  labels: {
    details: {
      en: "Details",
      ar: "التفاصيل",
    },
    dwellingLabel: { en: "Design" },
    dwellingBuilder: { en: "Builder" },
    dwellingDesign: { en: "Design" },
    dwellingSize: { en: "House Area" },
    dwellingSizeSuffix: { en: "m<sup>2</sup>" },
    propertySizeSuffix: { en: "m<sup>2</sup>" },
    dwellingFeatures: { en: "Features" },
    dwellingDescription: { en: "description" },
    dwellingPrice: { en: "Price From" },
    dwellingBeds: { en: "Beds" },
    dwellingBaths: { en: "Baths" },
    dwellingCars: { en: "Cars" },
    propertyLabel: { en: "Lot Number" },
    propertySize: { en: "Land Area" },
    propertyPrice: { en: "Price" },
    packagePrice: {
      en: "Price",
      ar: "السعر",
    },
    frontage: { en: "Frontage" },
    frontageSuffix: { en: "m" },
    depth: { en: "Depth" },
    depthSuffix: { en: "m" },
    description: {
      en: "Description",
      ar: "وصف",
    },
    exploreCommunities: {
      en: "Explore Communities",
      ar: "استكشاف المجتمعات",
    },
    features: {
      en: "Features",
      ar: "المواصفات​",
    },
    openingHours: {
      en: "Opening Hours",
      ar: "ساعات العمل",
    },
    backButton: {
      en: "Back",
    },
    favouritesButton: {
      en: "View Favourites",
      ar: "عرض المفضلة",
    },
    addToFavourites: {
      en: "Add to Favourites",
      ar: "أضف إلى المفضلة",
    },
    available: {
      en: "Available",
      ar: "متاح",
    },
    onHold: {
      en: "On Hold",
      ar: "لم يطلق",
    },
    sold: {
      en: "Sold",
      ar: "مباع",
    },
    viewLabel: {
      en: "Aspect",
    },
  },

  iconSet: "fas", // fas (solid), far (regular), fal (light), fad (duotone)

  skipOnlyChildLivingOptions: false,
  skipOnlyChildSubsections: true,

  showRegistrationModalOnQr: true,

  touchPrompt: {
    bottom: "15%",
    left: "50%",
  },

  general: {
    useSidebarSubnavigation: false,
    showFavourites: true,
    canAddSoldPropertiesToFavourites: true,
    showArtistImpressionText: true,
    artistImpressionPosition: "bottom-right",
    propertyModalViewImagesDisclaimer: "",
    showOnHoldGraphic: false,
    showSensorealBranding: true,
    showHomeButton: false,
    showPackagesWithSoldLots: false, // not implemented
    showSoldNeighbourhoods: true,
    showSoldReleases: true, // not implemented
    showSoldLabel: false,
    showSoldSlides: true, // third-level subsection nav
    showSoldPrice: true,
    showLayoutSwitchToggle: false,
    canInteractSoldLivingoptions: true,
    fadeSoldLivingOptions: true,
    canInteractSoldSubsections: true, // not implemented
    canInteractSoldProperties: true,
    canInteractOnHoldProperties: true,
    canInteractNotReleasedProperties: true,
    disclaimer: "",
    selectorHost: "", // not used here?
    selectorName: "", // not used here?
    analytics: false,
    ignorePropertyStatusFiltering: [""],
    showPrice: true,
    showProductCountWidget: false,
    appResetTimeoutMinutes: 10,
    accessCodeTimeout: 60 * 60 * 1000,
    autoplayAssetViewer: false,
  },

  filter: {
    enabled: true,

    propertyType: true,
    propertyView: true,
    propertyLotSize: true,
    propertyPriceRange: true,
    propertyStatus: true,
    dwellingDisplayName: true,
    dwellingBeds: true,
    dwellingBaths: true,
    dwellingCars: true,
    dwellingSize: true,
    dwellingPrice: true,
    dwellingHouseDesign: false,
  },

  hideLivingoptionSlides: false,

  minimapPositionPage: "top", // top or bottom
  minimapPositionNowSelling: "top",

  landPage: {
    active: true,
    label: "",
  },

  turnkeyPage: {
    active: false,
    label: "Townhomes",
    types: ["land", "house", "townhouse"],
  },

  dwellingPage: {
    active: false,
    label: "",
    types: ["house", "townhouse", "apartment"],
  },

  packagePage: {
    active: false,
    label: "",
  },

  displayHomesPage: {
    active: false,
    label: "Display Village",
  },

  propertyCard: {
    headingColour: "",
    priceLabel: {
      land: "Land Price From",
      package: "Package Price",
      dwelling: "House Price From",
      turnkey: "Price",
    },
  },

  propertyModal: {
    showSuitableDwellingsButton: false,
    suitableDwellingsButtonLabel: "House Options",
    associatedPackagesButtonLabel: "View Packages",
  },

  rightSidebar: {
    propertyGuide: {
      active: true,
      items: ["Available", "On Hold", "Sold"],
    },
  },

  markerIcons: {
    // land: ["far", "check"],
  },

  markers: {
    notReleased: {
      color: "#7f7f7f",
      hide: false,
      icon: ["fas", "horizontal-rule"],
      pulse: false,
      label: {
        en: "Not Released",
      },
    },
    comingSoon: {
      color: "#82aeeb",
      hide: false,
      icon: ["fas", "horizontal-rule"],
      pulse: false,
      label: {
        en: "Coming Soon",
      },
    },
    available: {
      color: "#6ed46b",
      hide: false,
      icon: ["fas", "check"],
      pulse: true,
      label: {
        en: "Available",
      },
    },
    onHold: {
      color: "#f38433",
      hide: false,
      icon: ["fas", "horizontal-rule"],
      pulse: false,
      label: {
        en: "On Hold",
      },
    },
    sold: {
      color: "#c82133",
      hide: false,
      icon: ["fas", "horizontal-rule"],
      pulse: false,
      label: {
        en: "Sold",
      },
    },
    builderLots: {
      color: "#82aeeb",
      hide: false,
      icon: ["fas", "horizontal-rule"],
      pulse: false,
      label: {
        en: "Builder Lot",
      },
    },
    displayHome: {
      color: "#2f5a79",
      hide: false,
      icon: ["fas", "house"],
      pulse: true,
      label: {
        en: "Display Home",
      },
    },
    homeSeeker: {
      color: "#56247e",
      hide: false,
      icon: ["fas", "house"],
      pulse: true,
      label: {
        en: "Home Seeker",
      },
    },
  },
};
